import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { CustomBackdrop } from '../../components/backdrop';
import {
  IntroduceMutation,
  IntroduceMutationVariables,
  MarkActivityMutation,
  MarkActivityMutationVariables,
} from '../../data-access/gql-types/graphql';
import { INTRODUCE } from '../../data-access/mutations/invitation';
import { MARK_ACTVITY } from '../../data-access/mutations/user';
import { useNotify } from '../../hooks/notifications/use-notify';
import { useFetchUser } from '../../hooks/user/use-fetch-user';
import { ExalusBackdropPopup } from '../../integrations/exalus/components/exalus-backdrop-popup';
import { useFetchActions } from '../../integrations/lavva/hooks/actions/use-fetch-actions';
import { useLavvaAppState } from '../../integrations/lavva/hooks/app-state';
import { useFetchChannels } from '../../integrations/lavva/hooks/devices-and-channels/use-fetch-channels';
import { useFetchDevices } from '../../integrations/lavva/hooks/devices-and-channels/use-fetch-devices';
import { useFetchGroups } from '../../integrations/lavva/hooks/groups/use-fetch-groups';
import { useFetchMeasurementMap } from '../../integrations/lavva/hooks/measurement-map/use-fetch-measurement-map';
import { useFetchVersionMap } from '../../integrations/lavva/hooks/version-map/use-fetch-version-map';
import { ChannelSubscriptions } from '../../integrations/lavva/modules/channel-subscriptions';
import { BluetoothNotSupportedDialog } from '../../integrations/lavva/modules/device-add/components/bluetooth-not-supported-dialog';
import * as storage from '../../integrations/lavva/storage';
import { enableScroll } from '../../utils/helpers/scroll';
import { toastError } from '../../utils/toast';
import { useSetEvaluateDialogTimeStart } from './hooks/use-set-evaluate-dialog-time-start';
import { useSetLanguage } from './hooks/use-set-language';

export const OverApp: React.FC = () => {
  const { t: tc } = useTranslation('common');
  const [invitationIntroduce] = useMutation<IntroduceMutation, IntroduceMutationVariables>(INTRODUCE);
  const [markActivity] = useMutation<MarkActivityMutation, MarkActivityMutationVariables>(MARK_ACTVITY);
  useFetchUser();
  useFetchGroups();
  useFetchActions();
  useFetchChannels();
  useFetchDevices();
  useFetchMeasurementMap();
  useFetchVersionMap();

  useLavvaAppState();
  useNotify();
  useSetLanguage();
  useSetEvaluateDialogTimeStart();

  useEffect(() => {
    markActivity();

    if (!storage.getItem('wasIntroduced')) {
      invitationIntroduce({
        onCompleted: (res) => {
          if (res.introduce) storage.setItem('wasIntroduced', true);
          else toastError({ content: tc('errors.somethingWentWrong') });
        },
      });
    }
  }, []);

  useEffect(() => {
    enableScroll();
  }, [location.pathname]);

  return (
    <>
      <CustomBackdrop />
      <ExalusBackdropPopup />
      <BluetoothNotSupportedDialog />

      <ChannelSubscriptions />
    </>
  );
};
